import React, { Component } from "react";
import PropTypes from "prop-types";
import { Table } from "antd";

import { req_list_lrs_lend_workflow } from "../../api";
import storageUtils from "../../utils/storageUtils";
import { formateDate } from "../../utils/dateUtil";

export default class ConfirmorReviewWorkflow extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    workflows: [],
  };

  static propTypes = {
    CaseId: PropTypes.string.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.api_list_workflow(this.props.CaseId);
    this.init_columns();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_workflow = async (uid) => {
    this.setState({ loading: true });
    const result = await req_list_lrs_lend_workflow(
      uid,
      storageUtils.getUser().token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const workflows = result.data;
      this.setState({ workflows });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "作業人員",
        dataIndex: "EventUserName",
        width: 60,
        responsive: ["md"],
      },
      {
        title: "作業日期",
        dataIndex: "CaseStampDataTime",
        width: 65,
        render: (CaseStampDataTime) => formateDate(CaseStampDataTime),
      },
      {
        title: "作業說明",
        dataIndex: "CaseStampDescription",
        width: 100,
      },
    ];
  };

  ////////////////////////////////////////////////////////////

  render() {
    // const { CaseNid } = this.props
    const { workflows } = this.state;
    return (
      <>
        <Table
          dataSource={workflows}
          columns={this.columns}
          pagination={false}
          rowKey="CaseUid"
        />
      </>
    );
  }
}
